<template>
  <footer class="footer">
    <ul class="footer__list">
      <li class="footer__list--item">
        <router-link
          :to="{ path: `/${langPath}privacy` }"
          class="footer__list--item__link"
        >
          {{ Footer.privacy[lang] }}
        </router-link>
      </li>
      <li class="footer__list--item">
        <router-link
          :to="{ path: `/${langPath}question` }"
          class="footer__list--item__link"
        >
          FAQ
        </router-link>
      </li>
      <li class="footer__list--item">
        <router-link
          :to="{ path: `/${langPath}contact` }"
          class="footer__list--item__link"
        >
          {{ Footer.contact[lang] }}
        </router-link>
      </li>
      <li class="footer__list--item">
        <a
          :href="Footer.pdf[lang]"
          target="_blank"
          rel="noopener"
          class="footer__list--item__link"
        >
          {{ Footer.regulation[lang] }}
        </a>
      </li>
    </ul>
    <small class="copy-right flex-all-center">
      © Tokyo Marathon Foundation All Rights Reserved
    </small>
  </footer>
</template>

<script>
import Footer from "../../assets/constants/footer";
export default {
  computed: {
    Footer: function () {
      return Footer;
    },
    lang: function () {
      return this.$store.state.lang;
    },
    langPath: function () {
      return this.$store.state.langPath;
    },
  },
  name: "CommonFooter",
};
</script>

<style scoped>
.footer {
  padding: 36px 15px 20px 15px;
  background-color: #000;
  &__list {
    display: flex;
    justify-content: center;
    &--item {
      padding: 0 20px;
      &__link {
        font-size: 20px;
        font-weight: 500;
        color: #fff;
        &:hover {
          border-bottom: solid 1px #fff;
        }
      }
    }
  }
  .copy-right {
    margin: 40px 0 0 0;
    font-size: 16px;
    font-weight: 300;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/CommonFooter.vue